import { useTranslation } from 'react-i18next';
import VideoCard from '@/components/feature/VideoCard';
import { videos } from '@/mocks/videos';

export default function LatestVideos() {
  const { t } = useTranslation();
  const latest = videos.slice(0, 8);

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
          <i className="ri-timer-line text-secondary-500 mr-2"></i>
          {t('latest.title')}
        </h2>
        <a
          href="/category/all"
          className="text-sm text-foreground-400 hover:text-primary-500 transition-colors duration-200 flex items-center gap-1 whitespace-nowrap cursor-pointer"
        >
          查看全部 <i className="ri-arrow-right-line text-xs"></i>
        </a>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
        {latest.map((video) => (
          <VideoCard key={video.id} video={video} />
        ))}
      </div>
    </section>
  );
}